import { render, staticRenderFns } from "./HomeIndex.vue?vue&type=template&id=79748036&"
import script from "./HomeIndex.vue?vue&type=script&lang=js&"
export * from "./HomeIndex.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports